import React from 'react';
import {useTheme} from "@mui/material/styles";
import {getAccountInfo} from "../../../utils/GenericUtils";
import {blueGrey} from "@mui/material/colors";
import {Avatar, Typography} from "@mui/material";
import moment from "moment";
import SVG from "react-inlinesvg";
import multiavatar from "@multiavatar/multiavatar";
import {formatText} from "./ChatFab";

export const MessagesChat = ({messages, notification, group, status}) => {
	let theme = useTheme();
	
	return (
		<React.Fragment>
			<div style={{overflowY: "auto", padding: 10, paddingTop: 20}}>
				
				{
					status === "OFFLINE" ?
						<div>Huston, we have a problem...</div> :
						status === "DISCONNECTED" ?
							<div>La vita non è sempre rosa e fiori, alle volte ci sono anche le margherite... maledette
								margherite</div> :
							group === "" ? <div>
									Hey, seleziona un gruppo per iniziare!
								</div> :
								messages?.filter(elem => elem.channel === group)?.length === 0 ?
									<div>Nessuno che scrive qui... dai, rompi il ghiaccio 🥳💪🏼🦄❄️ ☃️ ⛄️⛏⛏</div> :
									messages?.filter(elem => elem.channel === group)?.map((mess, index) => {
										
										let id = `mess-${index}`;
										
										if (mess.sender === getAccountInfo().username) {
											return (
												<div key={index} id={id}
												     style={{display: "grid", gridTemplateColumns: "1fr 40px", marginBottom: 8}}>
													<div style={{
														padding: 10,
														paddingLeft: 16,
														backgroundColor: theme.palette.mode === "light" ? blueGrey[100] : blueGrey[700],
														borderRadius: 22,
														margin: 4
													}}>
														<Typography variant={"caption"} style={{display: "flex"}}>
															<b style={{flexGrow: 1}}>{mess.alias}</b><span
															style={{
																fontSize: 12,
																paddingRight: 6,
																marginTop: -4,
															}}>{moment(new Date(mess.time)).format("HH:mm")}</span>
															<br/>
														</Typography>
														<Typography variant={"caption"}
														            style={{
															            overflowWrap: "anywhere",
															            color: theme.palette.mode === "light" ? blueGrey[900] : blueGrey[50]
														            }}>
															{formatText(mess.text)}
														</Typography>
													</div>
													<div>
														<Avatar>
															<SVG src={multiavatar(mess.alias)}/>
														</Avatar>
													</div>
												</div>
											)
										} else {
											return (
												<div key={index} style={{display: "grid", gridTemplateRows: "auto 1fr"}}>
													{
														notification[mess.channel] === mess.id &&
														<Typography variant={"caption"} align={"center"}
														            style={{
															            width: 180,
															            padding: 2,
															            margin: "auto",
															            backgroundColor: "rgba(0,0,0,0.3)",
															            color: "#FFF",
															            marginBottom: 6,
															            borderRadius: 22
														            }}>MESSAGGI NON LETTI</Typography>
													}
													<div id={id}
													     style={{display: "grid", gridTemplateColumns: "40px 1fr", marginBottom: 8}}>
														<div>
															<Avatar>
																<SVG src={multiavatar(mess.alias)}/>
															</Avatar>
														</div>
														<div style={{
															padding: 10,
															paddingLeft: 16,
															backgroundColor: theme.palette.mode === "light" ? blueGrey[100] : blueGrey[700],
															borderRadius: 22,
															margin: 4
														}}>
															<Typography variant={"caption"} style={{display: "flex"}}>
																<b style={{flexGrow: 1}}>{mess.alias}</b> <span
																style={{
																	fontSize: 12,
																	paddingRight: 6,
																	marginTop: -4,
																}}>{moment(new Date(mess.time)).format("HH:mm")}</span>
																<br/>
															</Typography>
															<Typography variant={"caption"}
															            style={{
																            overflowWrap: "anywhere",
																            color: theme.palette.mode === "light" ? blueGrey[900] : blueGrey[50]
															            }}>
																{formatText(mess.text)}
															</Typography>
														</div>
													</div>
												</div>
											)
										}
									})
				}
			</div>
		</React.Fragment>
	);
};
